import { render, staticRenderFns } from "./DialogCloseButton.vue?vue&type=template&id=48e56e2a&scoped=true&"
var script = {}
import style0 from "./DialogCloseButton.vue?vue&type=style&index=0&id=48e56e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e56e2a",
  null
  
)

export default component.exports